import { render, staticRenderFns } from "./LbTab.vue?vue&type=template&id=9177c39e"
import script from "./LbTab.vue?vue&type=script&lang=js"
export * from "./LbTab.vue?vue&type=script&lang=js"
import style0 from "./LbTab.vue?vue&type=style&index=0&id=9177c39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_etfl7lgzzfti5tuwpbu7orzhm4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports